import React, { useEffect, useRef, useState } from 'react';
import { Search } from '@mui/icons-material';
import "./Search.css";
import { useNavigate, useLocation } from "react-router-dom";

import { SearchStateParams } from "components/portal/documents/search/DocumentSearchState";

// There are issues with the % symbol and how React routing handles these
// For now filter them out in cases when they were causing issues
export const encodeTerm = (term: string) => {
    return term.replaceAll('%', '');
}

// If encoding % characters is handled later, will likely need some sort of matching decoding
export const decodeTerm = (term: string) => {
    if (!term) {
        return '';
    }
    return term;
}

export const Searchbar = React.forwardRef<HTMLInputElement | null, any>((props: { filters?: Array<string>, onChange?: (text: string) => void }, ref) => {
    const [searchText, setSearchText] = useState('');

    const navigate = useNavigate();
    const location = useLocation();

    const searchOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (typeof e.target.value === 'string') {
            setSearchText(e.target.value);
        }

        if (props.onChange) {
            props.onChange(e.target.value);
        }
    }

    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            search();
        }
    }

    const search = () => {
        const searchState: SearchStateParams = { from: location.pathname };
        navigate(`/search/${encodeTerm(searchText)}`,searchState);
    }

    return (
        <div className="search-bar">
            <div className="search-bar-icon" onClick={search}>
                <Search fontSize="inherit" />
            </div>
            <div className="search-border w-100 sub-header-searchBox">
                <input ref={ref}
                    type="text"
                    name="search"
                    id="search"
                    className="main-search-bar"
                    placeholder="Search"
                    maxLength={500}
                    autoComplete="off"
                    onKeyDown={handleKeyDown}
                    onChange={searchOnChange} />
            </div>
        </div>
    )
});

export default Searchbar;
